import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Argument} from "./Shot";
import {host} from "./api";


export interface ArgumentState {
    status: Status,
    error: string | null | undefined
}

const initialState: ArgumentState = {
    status: Status.Idle,
    error: null,
}

export const saveArgument = createAsyncThunk('saveArgument', async (params: { projectId: number, actionId: number, argument: Argument }) => {
    const response = await axios.post(`${host}/actions/${params.actionId}/arguments`,
        params.argument,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteArgument = createAsyncThunk('deleteArgument', async (params: { projectId: number, argumentId: number }) => {
    const response = await axios.delete(`${host}/arguments/${params.argumentId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const argumentSlice = createSlice({
    name: 'choices',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(saveArgument.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveArgument.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteArgument.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteArgument.fulfilled, (state, action) => {
                state.status = Status.Idle
            })

    }
})
export default argumentSlice.reducer;